<template>
  <div v-if="showBanner" class="cookie-banner">
    <p>
      Folosim cookie-uri esențiale pentru buna funcționare a site-ului.
      Continuând, accepți utilizarea acestora.
    </p>
    <div class="button-group">
      <button @click="acceptCookies">Accept</button>
      <button @click="declineCookies" class="decline">Refuz</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBanner: !localStorage.getItem("cookiesAccepted"),
    };
  },
  methods: {
    acceptCookies() {
      localStorage.setItem("cookiesAccepted", true);
      this.showBanner = false;
    },
    declineCookies() {
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  max-width: 300px;
  background: #333;
  color: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.button-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.cookie-banner button {
  background: goldenrod;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: bold;
  border-radius: 4px;
  width: 100%;
}
.cookie-banner .decline {
  background: goldenrod;
}
</style>
